import {Icon} from '@iconify/react';

import type {SVGProps} from 'react';

export function SquareAltArrowLeftLinearIcon(props: SVGProps<SVGSVGElement>) {
  return <Icon icon="solar:square-alt-arrow-left-linear" {...(props as object)} />;
}
